import type { ReactNode } from "react";
import { ApolloProvider } from "@apollo/client/react";
import { apolloClient } from "./client";

// Minimal provider. No useMemo, no auth-flip recreation. The client
// is module-level; the provider exists only to expose it via React
// context.

export function GraphQLProvider({ children }: { children: ReactNode }) {
  return <ApolloProvider client={apolloClient}>{children}</ApolloProvider>;
}
